module.exports = __webpack_public_path__ + "img/第5章_3-4_水牢紙條.jpg";